<template>
  <b-modal ref="modal" title="Duplicate Course Details" scrollable @hide="hide">
    <b-form v-if="categories && categories.length > 0">
      <b-form-group label="Course Full Name">
        <b-form-input
          v-model="newCourseFullName"
          @input="validateName('full')"
        />
        <small v-if="fullNameError" class="text-danger">{{
          fullNameError
        }}</small>
      </b-form-group>
      <b-form-group label="Course Short Name" @input="validateName('short')">
        <b-form-input v-model="newCourseShortName" />
        <small v-if="shortNameError" class="text-danger">{{
          shortNameError
        }}</small>
      </b-form-group>
      <b-form-group label="Course Category">
        <b-form-select
          v-model="selectedCategoryId"
          :options="formattedCategories"
          class="custom-instance-select"
          size="sm"
        />
      </b-form-group>
    </b-form>
    <div v-else-if="categories && categories.length == 0">
      No course categories available. Please add one first!
    </div>
    <template #modal-footer>
      <b-button class="btn" @click="hide">Close</b-button>
      <button
        class="btn btn-cp"
        :disabled="fullNameError || shortNameError || !selectedCategoryId"
        @click="createCourse"
      >
        Create
      </button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    courseId: {
      type: Number,
      default: null,
    },
    instanceId: {
      type: Number,
      default: 11,
    },
  },
  data() {
    return {
      newCourseFullName: "",
      newCourseShortName: "",
      shortNameError: null,
      fullNameError: null,
      selectedCategoryId: null,
    };
  },
  computed: {
    ...mapGetters({
      categories: "$_moodle_course/getCategories",
      courses: "$_moodle_course/getCourses",
    }),
    formattedCategories() {
      return [
        { value: null, text: "Choose a category" },
        ...(this.categories || []).map((cat) => ({
          value: cat.id,
          text: cat.name,
        })),
      ];
    },
  },
  watch: {},
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.newCourseFullName = "";
      this.newCourseShortName = "";
      this.shortNameError = null;
      this.fullNameError = null;
      this.selectedCategoryId = null;
      this.$refs.modal.hide();
    },
    createCourse() {
      const data = {
        instanceId: this.instanceId,
        courseId: this.courseId,
        newCourseFullName: this.newCourseFullName,
        newCourseShortName: this.newCourseShortName,
        categoryId: this.selectedCategoryId,
      };

      this.$store.dispatch("$_moodle_course/duplicateCourse", data);
      this.hide();
    },
    validateName(type) {
      if (type == "full") {
        if (this.newCourseFullName) {
          const isExisting = this.courses.some(
            (course) => course.fullname === this.newCourseFullName
          );
          this.fullNameError = isExisting
            ? "Course alread exists with this name."
            : null;
        }
      }
      if (type == "short") {
        if (this.newCourseShortName) {
          const isExisting = this.courses.some(
            (course) => course.shortname === this.newCourseShortName
          );
          this.shortNameError = isExisting
            ? "Course alread exists with this name."
            : null;
        }
      }
    },
  },
};
</script>

<style scoped>
::v-deep .modal-header {
  padding: 0.75rem !important;
}

.custom-instance-select {
  font-size: 1rem;
  max-width: 200px;
  border-radius: 4px;
}
</style>
